import { gql } from '@apollo/client';

/**
 * PostGraphile auto-generates this from gastrograph.perception_model_project.
 * "Project" and "norm set" are the same thing; the UI keeps the norm set
 * wording because the console already has an unrelated Projects section.
 *
 * anchors and normSet are jsonb, which maps to the JSON scalar.
 * id and createdDate are DB-defaulted and must not be sent.
 * producerId is NOT NULL with no default, so the caller must send it: a norm
 * set belongs to the workspace it was built in.
 */
export default gql`
  mutation CreatePerceptionModelProject(
    $normSet: PerceptionModelProjectInput!
  ) {
    createPerceptionModelProject(input: { perceptionModelProject: $normSet }) {
      perceptionModelProject {
        id
        name
        perceptionModelJobId
        producerId
        anchors
        normSet
        createdDate
      }
    }
  }
`;
